<template>
  <WordCloud :words="topNamesRef" :width="width" :height="height" :select-mode="selectMode" @click="onWordClick"/>
</template>

<style lang="scss" scoped>
</style>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNameCounts } from './NameCounts'
import WordCloud from '@/util/WordCloud.vue'

const props = defineProps<{
  width?: number
  height?: number
  selectMode?: boolean
}>()

const topCount = 100

const nameCounts = useNameCounts()

const topNamesRef = computed(() => (nameCounts.nameCounts.get('s')?.slice(0, topCount) ?? [])
  .map(n => ({ text: n.value, size: n.count })))

function onWordClick(word: string) {
  alert(word)
}
</script>
